































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Layout from '@/layouts/Default.vue';
import ListBlock from '@/views/CRUD/ListTab.vue';
import InputBase from '@/components/input/Input.vue';
import SelectCustom from '@/components/select/SelectCustom.vue';
import BaseButton from '@/components/buttons/BaseButton.vue';
import repository from '@/store/analysisCalculator';
import { CatalogKind, Choice, choices, tabs, errorMessage } from '@/api/analysisCalculator';

@Component({ components: { Layout, ListBlock, InputBase, SelectCustom, BaseButton } })
export default class CalculatorList extends Vue {
    @Prop({ required: true }) kind!: CatalogKind;
    repository = repository;
    tabs = tabs;
    query = '';
    categories: Choice[] = [];
    category: Choice | null = null;
    active = { id: '', value: 'Все' };
    activity = [{ id: '', value: 'Все' }, { id: 'true', value: 'Активные' }, { id: 'false', value: 'Неактивные' }];
    optionsError = '';
    get total() { return (this.repository.pageSettings.table as any).totalItems || 0; }
    get filtered() { return !!(this.repository.query || this.repository.category || this.repository.active); }
    @Watch('kind', { immediate: true }) configure() {
        this.repository.configure(this.kind);
        this.query = ''; this.category = null; this.active = this.activity[0];
        if (this.kind === 'analyses') this.loadCategories();
    }
    async loadCategories() {
        this.optionsError = '';
        try { this.categories = [{ id: 0, value: 'Все категории' }, ...await choices('categories')]; }
        catch (error) { this.optionsError = errorMessage(error); }
    }
    search() {
        this.repository.setFilters({ query: this.query.trim(), category: this.category?.id ? String(this.category.id) : '', active: this.active?.id || '' });
        this.repository.getList();
    }
    reset() { this.query = ''; this.category = null; this.active = this.activity[0]; this.search(); }
}
